import {
  ReactSelect,
  ReactSelectCodeAPE,
  ReactSelectCompanies,
  ReactSelectCountries,
  ReactSelectCustomizableAttributesAsync,
  ReactSelectDegrees,
  ReactSelectFieldOfStudies,
  ReactSelectIndustries,
  ReactSelectJobFunctions,
  ReactSelectNationalities,
  ReactSelectSchools,
  ReactSelectSkills,
  ReactSelectSubnetworks,
  ReactSelectTimezones,
  ReactSelectUserCustomizableAttributes,
  ReactSelectUsers,
} from 'hb-react/shared/components/ReactSelect';
import ReactSelectMentoringProfile from 'hb-react/shared/components/ReactSelect/ReactSelectMentoringProfile';

const getSelectComponent = (type) => {
  switch (type) {
    case 'countries':
      return ReactSelectCountries;

    case 'timezone':
      return ReactSelectTimezones;

    case 'industries':
      return ReactSelectIndustries;

    case 'companies':
      return ReactSelectCompanies;

    case 'job_functions':
      return ReactSelectJobFunctions;

    case 'skills':
      return ReactSelectSkills;

    case 'users':
      return ReactSelectUsers;

    case 'mentors':
    case 'mentees':
      return ReactSelectMentoringProfile;

    case 'nationalities':
      return ReactSelectNationalities;

    case 'sub_networks':
      return ReactSelectSubnetworks;

    case 'schools':
      return ReactSelectSchools;

    case 'field_of_studies':
      return ReactSelectFieldOfStudies;

    case 'degrees':
      return ReactSelectDegrees;

    case 'codeAPE':
      return ReactSelectCodeAPE;

    case 'customizable_attribute_select_async':
      return ReactSelectCustomizableAttributesAsync;

    case 'user_customizable_attributes':
      return ReactSelectUserCustomizableAttributes;

    case 'default':
    default:
      return ReactSelect;
  }
};

export default getSelectComponent;
